module.exports = new __parcel__URL__("dog-icon.1c9050b4.svg").toString();